/* -------------------------------------------------------------------------- */
/*                                App variables                               */
/* -------------------------------------------------------------------------- */

export const appInsights = window.appInsights;
export const appInsightsConnectionString = window.appInsightsConnectionString;
export const appInsightsSamplingPercentage = window.appInsightsSamplingPercentage;

/* -------------------------------------------------------------------------- */
/*                              Api URL variables                             */
/* -------------------------------------------------------------------------- */

export const environment = window.environment;
export const apiKey = window.apiKey;
export const fspApiLimit = window.fspApiLimit;
export const cardApiUrl = window.cardApiUrl;
export const cobaltBaseUrl = window.cobaltBaseUrl;
export const cobaltApiKey = window.cobaltApiKey;
export const cobaltApiUrl = window.cobaltApiUrl;
export const compApiUrl = window.compApiUrl;
export const pssApiUrl = window.pssApiUrl;
export const compStatsApiUrl = window.compStatsApiUrl;
export const standingsApiUrl = window.standingsApiUrl;
export const domesticApiUrl = window.domesticApiUrl;
export const drawApiUrl = window.drawApiUrl;
export const masApiUrl = window.masApiUrl;
export const matchApiUrl = window.matchApiUrl;
export const matchStatsApiUrl = window.matchStatsApiUrl;
export const bracketApiUrl = window.bracketApiUrl;
export const performanceApiBaseUrl = window.performanceApiBaseUrl;
export const sponsorApiUrl = window.sponsorApiUrl;
export const broadcasterApiUrl = window.broadcasterApiUrl;
export const uefaApiBaseUrl = window.uefaApiBaseUrl;
export const uefaBaseUrl = window.uefaBaseUrl;
export const storyTellerApiKey = window.storyTellerApiKey;

/* -------------------------------------------------------------------------- */
/*                              Assets variables                              */
/* -------------------------------------------------------------------------- */

export const imgBaseUrl = window.imgBaseUrl;
export const jwplayerScript = window.jwplayerScript;

/* -------------------------------------------------------------------------- */
/*                            Competition variables                           */
/* -------------------------------------------------------------------------- */

export const competitionBanner = window.competitionBanner;
export const competitionCode = window.competitionCode;
export const competitionName = window.competitionName;
export const competitionUrl = window.competitionUrl;
export const competitionFolder = window.competitionFolder;
export const competitionId = window.competitionId;
export const currentSeason = window.currentSeason;
export const competitionTracking = window.competitionTracking;

/* -------------------------------------------------------------------------- */
/*                             Tracking variables                             */
/* -------------------------------------------------------------------------- */

export const impressionScrollThreshold = window.impressionScrollThreshold;
export const impressionTimeThreshold = window.impressionTimeThreshold;

/* -------------------------------------------------------------------------- */
/*                            Advertising variables                           */
/* -------------------------------------------------------------------------- */
export const videoAdvTag = window.videoAdvTag;
export const videoAdsContext = window.videoAdsContext;
export const bannerAdsContext = window.bannerAdsContext;
export const sponsorPhase = window.sponsorPhase;

/* -------------------------------------------------------------------------- */
/*                            UEFA.tv variables                           */
/* -------------------------------------------------------------------------- */
export const uefaTvApiKey = window.uefaTvApiKey;
export const uefaTvRealm = window.uefaTvRealm;
export const uefaTvApiUrl = window.uefaTvApiUrl;
